var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 17 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.557 9.105c.248.123.443.448.443.724v12c0 .276-.197.399-.445.276l-3.656-1.83C7 19.83 7 19.383 7 18.83v-11c0-.553.402-.8.896-.553zm7.895-1.552 3.655 1.829c.893.447.893.894.893 1.447v11c0 .553-.399.8-.893.553l-3.655-1.83c-.247-.122-.452-.447-.452-.723v-12c0-.276.205-.4.452-.276m-1.67-.55c.12-.03.218.19.218.468v11.858c0 .276-.188.615-.425.757l-4.14 2.485a.7.7 0 0 1-.208.084c-.12.03-.227-.191-.227-.468V10.329c0-.276.195-.615.432-.757l4.146-2.485a.8.8 0 0 1 .204-.084"
})));
export default SvgMapSolid;